// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"f03706bb","401":"5e7bb3c3","497":"320a1e02","672":"5e7bb3c3","746":"37126d04","961":"7f5e8477"}[chunkId] + ".chunk.css";
};